import './index.css'
import { useState } from 'react'
import { Back2 } from '../../components/Option/Back'
import Add from '../../components/Option/Add'
import Delete from '../../components/Option/Delete'
import AddSubGoal, { AddGoal } from './AddSubGoal'
import '../Ambition/index.css'
import { ContainerBody } from '../../App'
const GoalStyle1 = () => {
    function getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const [add,setAdd] = useState(false);
    return (
        <div className="ambitiondetail__body__goal" style={{marginTop:"3.5vw"}}>
            <div style={{position:"relative",top:"30px"}} >
                <h4 className="ambitiondetail__goal__title">Employee Relations</h4>
            </div>
            <div className="ambitiondetail__goal__subgoal" style={{position:"relative",top:"20px",width:getRandomInt(80,95)+"%",marginLeft:getRandomInt(3,7)+"%"}}>
                <h4>Employee conditions ( Health Insurance, working environment )</h4>
            </div>
            <div className="ambitiondetail__goal__subgoal" style={{position:"relative",top:"10px",width:getRandomInt(80,95)+"%",marginLeft:getRandomInt(3,7)+"%"}}>
                <h4>Employee engagement and satisfaction score ( churn, satisfaction assesments... )</h4>
            </div>
            {
                add ?
                <div className="ambitiondetail__goal__subgoal" style={{position:"relative",top:"5px",width:getRandomInt(80,95)+"%",marginLeft:getRandomInt(3,7)+"%"}}>
                    <input type="text" className="custom__input" />
                    <Add header={"Add Sub-goal"}/>
                    <Delete header={"Delete Sub-goal"}/>
                </div>:
                <AddSubGoal/>
            }
            
            
        </div>
    );
}

const GoalStyle2 = () => {
    function getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    return (
        <div className="ambitiondetail__body__goal body__style2">
            <div style={{alignSelf:"flex-start",position:"relative",top:"30px"}} >
                <h4 className="ambitiondetail__goal__title goal__style2" >Human Rights</h4>
            </div>
            <div className="ambitiondetail__goal__subgoal subgoal__style2" style={{position:"relative",top:"20px",width:getRandomInt(80,95)+"%",marginRight:getRandomInt(3,7)+"%"}}>
                <h4>Access to healthcare (100%)</h4>
            </div>
            <div className="ambitiondetail__goal__subgoal subgoal__style2" style={{position:"relative",top:"10px",width:getRandomInt(80,95)+"%",marginRight:getRandomInt(3,7)+"%"}}>
                <h4>Minimum living wage(100%)</h4>
            </div>
            <AddSubGoal style={2}/>
        </div>
    );
}
const AmbitionDetail = () => {
    const [depart,setDepart] = useState({
        "title":"SDG",
        "subheading": "Sustainable Development Goals",
    })
    return ( 
        <ContainerBody className="ambition__body">
            <div className="ambitiondetail__wrapper2" style={{width:"100%",display:"flex",justifyContent:"flex-end",marginTop:"20px",height:"0"}}>
                <Back2 header={"Back to Ambition Page"} style={{marginRight:"auto",position:"relative",left:"-7%"}} to={"/ambition"}/>
                <div className="ambitiondetail__option" style={{position:"absolute",marginRight:"20px"}}>
                    <Delete header={"Delete Ambition"}/>
                </div>
            </div>
            <div className="ambitiondetail__body__row">
                <div className="ambitiondetail__body__item">
                    <h4>{depart.title}</h4>
                    <h5>{depart.subheading}</h5>
                </div>    
                <GoalStyle1/>
            </div>
            <div className="ambitiondetail__body__row">
                <GoalStyle2/>
            </div>
            <div className="ambitiondetail__body__row" style={{justifyContent:"flex-end",width:"100%"}}>
                <AddGoal/>
            </div>
            <div className="ambitiondetail__wrapper">
                <div className="ambitiondetail__option">
                    <Delete header={"Delete Ambition"}/>
                </div>
            </div>
        </ContainerBody>
     );
}
 
export default AmbitionDetail;